import { render, staticRenderFns } from "./PersonFrequencyCard.vue?vue&type=template&id=59e1bada&"
import script from "./PersonFrequencyCard.vue?vue&type=script&lang=js&"
export * from "./PersonFrequencyCard.vue?vue&type=script&lang=js&"
import style0 from "./PersonFrequencyCard.vue?vue&type=style&index=0&id=59e1bada&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports